import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { IUserDetails } from '../shared/models/UserDetailsOutputModel';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { IBrokerRegionalLicenses } from '../shared/models/BrokerRegionalLicensesInputModel';
import { ValidationService } from '../shared/providers/validation.service';
import { UserRole } from '../shared/enum/enum'
import { AuthenticationService } from '../shared/auth/authentication.service';
import { PermissionService } from '../shared/providers/permission.service';
import { Actions, Modules } from '../shared/enum/enum';

enum Tab {
  PersonalInformation = 1,
  ActivityLog = 2,
  InterestCriteria = 3,
  Associations = 4
}

@Component({
  selector: 'user-details',
  templateUrl: './user-details.component.html',

})

export class UserDetailsComponent {

  Modules = Modules;
  Actions = Actions;
  userDetailsOutput = {} as IUserDetails;
  brokerRegionalLicenses: Array<IBrokerRegionalLicenses> = [];
  userGuid: string = "";
  isExpiryDateValidate: number[] = [];
  userRole = UserRole;
  result = [];
  isViewAuditTrail = false;
  auditObjectId = 0;
  auditObjectTypeId = 0;
  viewOrHideLabel = "View";
  prevPage = "Employees";
  prevPageRouteLink = "users/employees";

  constructor(private _userManagerService: UserManagerService, public permissionService: PermissionService, private activatedRoute: ActivatedRoute, public authService: AuthenticationService, private router: Router, public _validationService: ValidationService) {

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.userGuid = params['user'];
      if (this.userDetailsOutput.ProfilePicPath === undefined || this.userDetailsOutput.ProfilePicPath === null || this.userDetailsOutput.ProfilePicPath.trim().length <= 0) {
        this.userDetailsOutput.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
      }
    });
  }
  User: any;

  ngOnInit() {
    //this.userDetailsOutput.UserRoleId = 7;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let routeName = params['prevroute'];
      let routeLink = params['link'];
      if (routeName !== null && routeName !== undefined) {
        this.prevPage = routeName;
        this.prevPageRouteLink = routeLink;
      }
    });

    this._userManagerService.getUserDetails(this.userGuid).subscribe(response => {
      this.userDetailsOutput = response;
      this.auditObjectId = this.userDetailsOutput.Id;
      this.auditObjectTypeId = 301;
      const user =
      {
        Id: response.Id,
        Name: response.FirstName + " " + response.LastName,
        Role: response.UserRoleId,
      }
      this.User = user;

      this._userManagerService.getBrokerages(user.Id).subscribe(response => {
        this.result = response;
      });

      if (this.userDetailsOutput.ProfilePicPath === undefined || this.userDetailsOutput.ProfilePicPath === null || this.userDetailsOutput.ProfilePicPath.trim().length <= 0) {
        this.userDetailsOutput.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
      }

      if (response.BrokerRegionalLicensesOutputModelList !== null) {
        //Converting  UTC Date into Local Date
        for (let i = 0; i < response.BrokerRegionalLicensesOutputModelList.length; i++) {
          if (response.BrokerRegionalLicensesOutputModelList[i].ExpiryDate !== null) {
            let UTCDate = (response.BrokerRegionalLicensesOutputModelList[i].ExpiryDate);
            var date = new Date(UTCDate + ' UTC');
            response.BrokerRegionalLicensesOutputModelList[i].ExpiryDate_Date = date;
          }
          else {
            response.BrokerRegionalLicensesOutputModelList[i].ExpiryDate_Date = null;
          }
        }
      }
      this.brokerRegionalLicenses = response.BrokerRegionalLicensesOutputModelList;
      this.isExpiryDateValidate = this._validationService.validateExpirationDate(this.brokerRegionalLicenses);
    });
  }
  tab = Tab;
  activeTab = Tab.PersonalInformation;
  onTabClick(selectedTab) {
    this.activeTab = selectedTab;
    if (this.activeTab === Tab.ActivityLog) {

    }
  }

  editUser() {
    this.router.navigate(['/employee-edit'], { queryParams: { user: this.userGuid.toString() } });
  }

  viewAuditTrail() {
    if (this.isViewAuditTrail == false) {
      this.isViewAuditTrail = true;
      this.viewOrHideLabel = "Hide";
    }
    else {
      this.isViewAuditTrail = false;
      this.viewOrHideLabel = "View";
    }
  }

  onBreadCrumbClick() {
    this.router.navigateByUrl(this.prevPageRouteLink);
  }
}
